const numericEquals = (a, b) => Number(a) === Number(b);

export const getExpectedCogsFromDefaults = (itemPrice, defaults) => {
    const price = Number(itemPrice);
    if (!Number.isFinite(price) || price <= 0) return null;
    return (price * defaults.cogsPercentOfPrice) / 100;
};

export const isProductHandEdited = (product, defaults) => {
    if (!product) return false;

    if (product.default_value_status != null) {
        return Number(product.default_value_status) === 1;
    }

    const fieldChecks = [
        ['replenishment_time', defaults.replenishmentDays],
        ['unsellable_returns_percentage', defaults.unsellableReturnsPercent],
        ['product_tax_code', defaults.taxPaidOnCogsPercent],
        ['vat_rate', defaults.taxCollectedOnSalesPercent],
    ];

    const hasManualFieldEdit = fieldChecks.some(([field, defaultValue]) => {
        const value = product[field];
        return value != null && value !== '' && !numericEquals(value, defaultValue);
    });

    if (hasManualFieldEdit) return true;

    if (product.item_cogs == null || product.item_cogs === '') return false;

    const expectedCogs = getExpectedCogsFromDefaults(product.item_price, defaults);
    if (expectedCogs == null) return true;

    return Math.abs(Number(product.item_cogs) - expectedCogs) > 0.5;
};

export const countHandEditedProducts = (products, defaults) => {
    if (!Array.isArray(products) || products.length === 0) return 0;
    return products.filter((product) => isProductHandEdited(product, defaults)).length;
};
